import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Observable, Subscription } from "rxjs";
import { tap } from "rxjs/operators";
import { PaginationParams } from "src/app/models/pagination-params";
import { RowAction, RowActionType, SortDetails, TableConfig, } from "src/app/models/table-config";
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
    selector: "app-table",
    templateUrl: "./table.component.html",
    styleUrls: ["./table.component.scss"],
    animations: [
        trigger('fadeIn', [
            state('void', style({ opacity: '0' })),
            transition('void <=> *', [animate('300ms ease-in')]),
        ]),
    ],
})
export class TableComponent<T> implements OnInit, OnDestroy {
    @Input() tableConfig: TableConfig<T>;
    @Input() paginationParams?: PaginationParams;
    @Input() filterForm: FormGroup;
    @Input() updatePaginationParams: Observable<boolean>;

    @Output() emitAction: EventEmitter<RowAction<T>> = new EventEmitter();
    @Output() emitSort: EventEmitter<SortDetails> = new EventEmitter();
    @Output() emitFilter: EventEmitter<PaginationParams> = new EventEmitter();

    showRowTooltip: Array<boolean>;

    private _currentSortDetails: SortDetails;
    private _subscriptions: Subscription = new Subscription();

    ngOnInit(): void {
        this.showRowTooltip = [].fill(false, 0, 100);
        if (this.paginationParams) {
            this._setPaginationParams(this.paginationParams.totalRecords);
            this._subscriptions.add(
                this.updatePaginationParams
                    .pipe(
                        tap(() => {
                            this._setPaginationParams(
                                this.paginationParams.totalRecords
                            );
                        })
                    )
                    .subscribe()
            );
        }
    }

    ngOnDestroy(): void {
        this._subscriptions.unsubscribe();
    }

    public emitRowAction(rowAction: RowAction<T>) {
        this.emitAction.emit(rowAction);
    }

    public emitSortAction(sortDetails: SortDetails) {
        this._currentSortDetails = sortDetails;
        this.emitSort.emit(sortDetails);
    }

    public emitFilterAction(paginationParams: PaginationParams) {
        this.emitFilter.emit(paginationParams);
    }

    public highlightSortIcon(sortDetails: SortDetails) {
        const currentSortDirection = this._currentSortDetails?.sortDirection;
        const latestSortDirection = sortDetails.sortDirection;

        const currentFilterInput =
            this._currentSortDetails?.tableHeader.sortId;
        const latestFilterInput = sortDetails.tableHeader.sortId;

        return currentSortDirection === latestSortDirection &&
            currentFilterInput === latestFilterInput
            ? true
            : false;
    }

    tooltipClick(ei, entity) {
        this.showRowTooltip[ei] = !this.showRowTooltip[ei];
        this.emitRowAction({
            actionType: RowActionType.Tooltip,
            entity
        });
    }

    private _setPaginationParams(dataLength: number) {
        this.paginationParams.pageArray = [];
        this.paginationParams.pages = Math.ceil(
            dataLength / this.paginationParams.limit
        );
        this.paginationParams.totalRecords = dataLength;

        for (let i = 0; i < this.paginationParams.pages; i++) {
            this.paginationParams.pageArray.push(i);
        }
    }
}
